import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=0c573189&scoped=true&"
import script from "./binding.vue?vue&type=script&lang=ts&"
export * from "./binding.vue?vue&type=script&lang=ts&"
import style0 from "./binding.vue?vue&type=style&index=0&id=0c573189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c573189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
